import React from 'react';
import { Loader } from '@grupa-pracuj/react-loader';

import 'src/components/Loader.scss';


const LoaderWrapper = () => (
  <div styleName="loader">
    <Loader />
  </div>
);


export default LoaderWrapper;
